import declare from "dojo/_base/declare";
import AggregateAttributeController from "csi/heading/AggregateAttributeController";
import PreferencePath from "csi/def/PreferencePath";


const ForProductSourceForFoodSourcing = declare(AggregateAttributeController, {

	/**
	 * @override
	 * Add custom preference paths to view
	*/
	onAggregateStoreTableView(tableView, nodeType) {
		tableView.getPageRelationship().m_prefPaths = [
			Object.assign(new PreferencePath(), {
				m_path: "Child:__Parent__",
			}),
			Object.assign(new PreferencePath(), {
				m_path: "Child:__Parent__/Child:__Parent__",
				bAddTargetPaths: true,
			}),
		];
	},


});

export = ForProductSourceForFoodSourcing;